import { render, staticRenderFns } from "./groupOrderStat.vue?vue&type=template&id=289295f3&"
import script from "./groupOrderStat.vue?vue&type=script&lang=js&"
export * from "./groupOrderStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports